import { render } from "./TwoFactorActivationModal.vue?vue&type=template&id=745e3b92"
import script from "./TwoFactorActivationModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorActivationModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__